import {
  timeYear,
  timeMonth,
  timeDay,
  timeHour,
  timeMinute,
  timeSecond,
} from 'd3-time';

import { formatDate } from '@dynatrace-sdk/units';
import { getRegionalFormat } from '@dynatrace-sdk/user-preferences';

import {
  formatYear,
  formatWeekday,
  formatSeconds,
  formatMonth,
  formatMinute,
  formatHour,
  formatDay,
} from './format-dates.js';

export function formatDateTicks(date: Date): string {
  const timeInMs = date.getTime();
  if (timeSecond(date) < date) {
    return formatSeconds(timeInMs);
  } else if (timeMinute(date) < date) {
    return formatMinute(timeInMs);
  } else if (timeHour(date) < date) {
    return formatHour(timeInMs);
  } else if (timeDay(date) < date) {
    const formattedDay = formatDay(timeInMs);
    const locale = getRegionalFormat();

    if (formattedDay.match(/am|pm/i)) {
      return formatDate(timeInMs, {
        hour: '2-digit',
        locale,
      });
    }

    return formatDate(timeInMs, {
      hour: '2-digit',
      minute: 'numeric',
      hourCycle: 'h24',
      locale,
    });
  } else if (timeMonth(date) < date) {
    return formatWeekday(timeInMs);
  } else if (timeYear(date) < date) {
    return formatMonth(timeInMs);
  } else {
    return formatYear(timeInMs);
  }
}
